import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientGrid: [],
    workClientAll: [],
    workClientShow: {
      name: '',
      logo: null,
    },
    pageData: null,
  },
  mutations: {
    setWorkClientGrid(state, payload) {
      state.workClientGrid = payload
    },
    setWorkClientAll(state, payload) {
      state.workClientAll = payload
    },
    setWorkClientShow(state, payload) {
      state.workClientShow = payload ? payload : {}
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workClientGrid: (state) => {
      return state.workClientGrid
    },
    workClientAll: (state) => {
      return state.workClientAll
    },
    workClientShow: (state) => {
      return state.workClientShow
    },
    pageData: (state) => {
      return state.pageData
    },
    workClientShowName: (state) => {
      return state.workClientShow.name
    },
  },
  actions: {
    onWorkClientGrid({commit, dispatch, rootState}, {limit, page, sort, search}) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      let url = rootState.apiDomain + '/api/admin/work/client/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimationFullPage', false, {root: true})
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientAll({commit, rootState}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/grid?limit=0' + '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientShow({commit, rootState}, id) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientShow', resp.data.data)
            commit('setLoadingAnimationFullPage', false, {root: true})
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            reject(err)
          })
      })
    },
    onWorkClientClear({commit}) {
      commit('setWorkClientShow', {})
    },
    onWorkClientCreate({rootState, dispatch, commit}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            commit('setWorkClientShow', {})
            resolve(resp)
            dispatch('popup/onMessage', {
              message: rootState.translations.notifications['uspeshno-dobavlen'],
              IsError: false
            }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientUpdate({rootState, dispatch, commit}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientRegistrationAddressUpdate({commit, dispatch, rootState}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/registration-address',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientBillingAddressUpdate({commit, dispatch, rootState}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/billing-address',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientDelete({commit, dispatch, rootState}, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {IsError: false}, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkClientSendOffer({rootState}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/send-offer',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
